import { useFormContext } from 'react-hook-form'
import { CheckoutFormData } from '../constants/types'

const useCheckoutFormContext = useFormContext<CheckoutFormData>
export default useCheckoutFormContext
